module.exports = __webpack_public_path__ + "static/media/joaquin.cc33db1d.jpg";